export default () => {
  const container = document.querySelector('[data-sticky]');

  if (!container) {
    return;
  }

  const sentinel = document.querySelector(container.dataset.sticky);

  if (!sentinel) {
    return;
  }

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        container.classList.toggle('is-stuck', !entry.isIntersecting);
      });
    },
    {
      threshold: 1,
    },
  );
  observer.observe(sentinel);
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/goodie-wp-chisel/src/scripts/modules/sticky.js